import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import { Automation } from 'modules/automations/store/models/Automation'

class AutomationsCollection extends Collection<Automation> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      default: computed,
      notDefault: computed,
    })
  }

  get cacheKey(): string {
    return 'automations'
  }

  model() {
    return Automation
  }

  get default(): Automation[] {
    return this.models.filter((automation) => !!automation.attributes.slug)
  }

  get notDefault(): Automation[] {
    return this.models.filter((automation) => !automation.attributes.slug)
  }
}

export const automations = new AutomationsCollection()
